import React from "react";

// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import TextInput from "../widgets/TextInput";
import FixButton from "../widgets/Button";
import MyDatePicker from "../widgets/DatePicker";
import SelectInput from "../widgets/SelectInput";
import Checkbox from "../widgets/CheckBox";
import moment from "moment";
import _ from 'lodash/cloneDeep';
import addUscita from "../services/addUscita";
import getFattura from "../services/getFattura";
import editFattura from "../services/editFattura";
import clearUscite from "../services/clearUscite";
import getImpostazioni from "../services/getImpostazioni";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });

export default class EditFattura extends React.Component {
    constructor(props){
        super (props)

        this.fatturaDateRef = React.createRef();
        this.customDispRef = React.createRef();

        this.disposizioni = [
            { value: 0, label: 'Immediato' },
            { value: 30, label: '30 GG.DF.FM.' },
            { value: 60, label: '60 GG.DF.FM.' },
            { value: 90, label: '90 GG.DF.FM.' },
            { value: 120, label: '120 GG.DF.FM.' },
            { value: 150, label: '150 GG.DF.FM.' },
            { value: 180, label: '180 GG.DF.FM.' },
            { value: 1000, label: 'Personalizza' }, 
        ];

        this.tipiDocumenti = [
            { value: 0, label: 'Non definito' },
            { value: 1, label: 'Fattura' },
            { value: 2, label: 'Fattura differita di cui l’art. 21, comma 4, lett. a' },
            { value: 3, label: 'Nota di Credito' },
            { value: 4, label: 'Acconto/Anticipo su Fattura' }
        ];

        this.tags = [];
        this.metodiPagamento = [];

        this.state = {
            ragioneSociale: '',
            numeroFattura: '', 
            dataFattura: undefined, 
            ritenuta: 0, 
            importo: '', 
            sdi: '', 
            tag: { value: undefined, label: '' }, 
            metodoPagamento: { value: undefined, label: '' },
            elettronica: 1,
            tipoDocumento: { value: 0, label: 'Non definito' },
            disposizioni: [{value: 0, label: 'Immediato'}],
            customDisposizione: false,
        };

    }

    async componentDidMount() {

        username = cookies.get('username', { path: '/' });
        token = cookies.get('token', { path: '/' });
    
        let current = cookies.get('fattura', { path: '/' });
        let fattura = await getFattura(username, token, current);
        let impostazioni = await getImpostazioni(username, token);

        if (!fattura.ragione_sociale && !fattura.data) {
            window.location.href = '/#/app/fatture';
            return;
        }

        this.tags = impostazioni.find(i => i.tipo === 'anagrafiche');
        this.tags = JSON.parse(this.tags.payload);
        this.tags.forEach((t, i) => {
            this.tags[i] = { value: parseInt(t.scarico), label: t.label }
        });
        this.tags = [{ value: 100, label: ""}, ...this.tags];

        this.metodiPagamento = impostazioni.find(i => i.tipo === 'pagamenti');
        this.metodiPagamento = JSON.parse(this.metodiPagamento.payload);
        this.metodiPagamento.forEach((t, i) => {
            this.metodiPagamento[i] = { value: t.label, label: t.label }
        });

        this.metodiPagamento = [{ value: "", label: ""}, ...this.metodiPagamento];
        
        let isCustomDisp = JSON.parse(fattura.disposizioni).find(d => d.value === 1000);
        let customDate = null;
        if (isCustomDisp) {
            JSON.parse(fattura.disposizioni).forEach((d, i) => {
                if (d.value === 1000) customDate = JSON.parse(fattura.date_disposizioni)[i].data;
            });
        }
        
        this.setState({
            ragioneSociale: fattura.ragione_sociale, 
            numeroFattura: fattura.numero, 
            ritenuta: parseInt(fattura.ritenuta), 
            importo: fattura.importo, 
            dataFattura: moment(fattura.data, 'DD/MM/yyyy').toDate(), 
            sdi: fattura.sdi, 
            tag: { value: parseInt(fattura.scarico_iva), label: fattura.tag }, 
            elettronica: fattura.elettronica,
            tipoDocumento: this.tipiDocumenti.find(t => t.label === fattura.tipo),
            disposizioni: JSON.parse(fattura.disposizioni), 
            metodoPagamento: { value: fattura.pagamento, label: fattura.pagamento }, 
            customDisposizione: isCustomDisp, 
            dataCustomDisposizione: moment(customDate, 'DD/MM/yyyy').toDate(),
        });
    }

    componentDidUpdate() {
        if (this.state.disposizioni) {
            var found = false;
            this.state.disposizioni.forEach(d => {
                if (d.value === 1000 && !this.state.customDisposizione) {
                    this.setState({ customDisposizione: true });
                    found = true;
                    return;
                } else if (d.value === 1000) {
                    found = true;
                    return;
                }
            });

            if (!found && this.state.customDisposizione) this.setState({ customDisposizione: false });
        }
    }

    render () {

        return (
        <>
            <PageTitle title={'Modifica fattura'} />

            <div style={{ display: 'flex', marginLeft: 3 }}>
                {this.state.metodoPagamento.label && (
                    <div style={{ backgroundColor: '#B6EEB8', boxShadow: '0px 1px 2px white', borderRadius: 5, marginTop: -25, marginBottom: 25, marginRight: 10 }}>
                        <p style={{ marginTop: 3, marginBottom: 3, marginLeft: 10, marginRight: 10 }}>{this.state.metodoPagamento.label}</p>
                    </div>
                )}
                {this.state.tag.label && (
                    <div style={{ backgroundColor: '#CED86B', boxShadow: '0px 1px 2px white', borderRadius: 5, marginTop: -25, marginBottom: 25 }}>
                        <p style={{ marginTop: 3, marginBottom: 3, marginLeft: 10, marginRight: 10 }}>{this.state.tag.label}</p>
                    </div>
                )}
            </div>

            <SelectInput
                key={Math.random()}
                value={this.state.tag} 
                name={"Tag"} 
                options={this.tags} 
                onChange={(option) => {
                    this.setState({ tag: option });
                }}
            />

            <SelectInput
                key={Math.random()}
                value={this.state.tipoDocumento} 
                name={"Tipo documento"} 
                options={this.tipiDocumenti} 
                onChange={(option) => {
                    this.setState({ tipoDocumento: option });
                }}
            />

            <TextInput name={'Ragione sociale mittente'} value={this.state.ragioneSociale} 
                onChange={(text) => { this.setState({ragioneSociale: text})}
            } />

            <TextInput name={'Numero fattura'} value={this.state.numeroFattura} 
                onChange={(text) => { this.setState({numeroFattura: text})}
            } />

            <MyDatePicker ref={this.fatturaDateRef} name={'Data fattura'} value={this.state.dataFattura} />

            <div style={{ height: 30 }}></div>


            <TextInput noState={true} name={'Importo fattura'} value={this.state.importo}
                onChange={(text) => {
                    var t = text.replace(/\./g, '');
                    if(/[^0-9,]+/.test(t)) {
                        t = t.replace(/[^0-9]+/g, '');
                    }
                    var chunks = t.split(',');
                    chunks[0] = chunks[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    t = chunks.join(',');
                    this.setState({importo: t.trim()});
                }}
            />

            <TextInput name={'Identificativo SDI'} value={this.state.sdi} 
                onChange={(text) => { this.setState({sdi: text})}
            } />

            <SelectInput
                key={Math.random()}
                value={this.state.disposizioni} 
                isMulti={true}
                name={"Disposizioni di pagamento"} 
                options={this.disposizioni} 
                onChange={(option) => {
                    this.setState({ disposizioni: option });
                }}
            />

            { this.state.customDisposizione && (
                <MyDatePicker ref={this.customDispRef} name={'Data disposizione'} value={this.state.dataCustomDisposizione} />
            )}

            <SelectInput
                key={Math.random()}
                value={this.state.metodoPagamento} 
                name={"Metodo di pagamento"} 
                options={this.metodiPagamento} 
                onChange={(option) => {
                    this.setState({ metodoPagamento: option });
                }}
            />

            <div style={{ marginLeft: 8, marginTop: 10, display: 'flex', alignItems: 'center' }}> 
                <p>Ritenuta d'acconto</p>
                <Checkbox
                    checked={this.state.ritenuta === 1 ? true : false} 
                    name={'ritenuta'} 
                    style={{ marginTop: 5, marginLeft: 15 }}
                    onElementCheck={(val) => this.setState({ ritenuta: val === true ? 1 : 0 })}
                />
            </div>

            <div style={{ marginLeft: 8, marginTop: -10, display: 'flex', alignItems: 'center' }}> 
                <p>Fattura non elettronica</p>
                <Checkbox
                    checked={this.state.elettronica === 0 ? true : false} 
                    name={'n_elettronica'} 
                    style={{ marginTop: 5, marginLeft: 15 }}
                    onElementCheck={(val) => this.setState({ elettronica: val === true ? 0 : 1 })}
                />
            </div><br/>

            <div style={{ height: 30 }}></div>
            <FixButton title={'Salva'} callback={() => this.save()} />
        </>
        );
    }

    async save() {

        this.setState({ isLoading: true });

        if (this.state.tipoDocumento.value === 0) {
            alert('Inserire una tipologia di documento valida');
            return;
        }

        if (!this.state.ragioneSociale) {
            alert('Inserire una ragione sociale valida');
            return;
        }

        if (!this.state.importo) {
            alert('Inserire un importo per la fattura');
            return;
        }

        if (this.state.disposizioni.length === 0) {
            alert('Inserire almeno una disposizione di pagamento');
            return;
        }

        var date = this.fatturaDateRef.current.getDate();
        date = moment(date).format('DD/MM/yyyy');

        var custom = [];
        let singolaRata = 0;
        if (this.state.importo.includes('.') && this.state.importo.includes(',')) {
            // Es: 1.000,00
            singolaRata = parseFloat(this.state.importo.replace(/\./g, '').replace(/,/g, '.'))/this.state.disposizioni.length;
        } else if (this.state.importo.includes('.') && this.state.importo.split('.')[1].length === 2) {
            // Es: 1000.00
            singolaRata = parseFloat(this.state.importo)/this.state.disposizioni.length;
        } else {
            // Es: 1000
            singolaRata = parseFloat(this.state.importo)/this.state.disposizioni.length;
        }
        singolaRata = singolaRata.toFixed(2);
        
        var dataFattura = moment(this.fatturaDateRef.current.getDate());
        dataFattura = _(dataFattura);
        let error = false;
        this.state.disposizioni.forEach(d => {
            var data = '';
            if (d.value === 0) {
                // Immediato
                data = dataFattura.format('DD/MM/yyyy');
            } else if (d.value === 1000) {
                // Personalizza
                const dataCustom = this.customDispRef.current.getDate();
                if (!dataCustom) {
                    alert('Inserire una data personalizzata per la disposizione di pagamento.');
                    error = true;
                }
                data = moment(dataCustom).format('DD/MM/yyyy');
            } else {
                var startDate = dataFattura.format('DD/MM/yyyy');
                let finalDate = moment(startDate, 'DD/MM/yyyy').add(d.value, 'days');
                data = finalDate.endOf('month').format('DD/MM/yyyy');
            }
            custom.push({ data: data, importo: singolaRata });

        });
        if (error) return;
        custom = custom.sort((a, b) => {
            return moment(a.data, 'DD/MM/yyyy').isBefore(b.data, 'DD/MM/yyyy') ? -1 : 1
        });

        let fattura = {
            id: cookies.get('fattura', { path: '/' }), 
            ragione_sociale: this.state.ragioneSociale, 
            tipo: this.state.tipoDocumento.label, 
            numero: this.state.numeroFattura, 
            data: date, 
            sdi: this.state.sdi, 
            importo: this.state.importo, 
            tag: this.state.tag.label, 
            scarico: this.state.tag.value, 
            pagamento: this.state.metodoPagamento ? this.state.metodoPagamento.label : '', 
            ritenuta: this.state.ritenuta, 
            elettronica: this.state.elettronica, 
            disposizioni: JSON.stringify(this.state.disposizioni), 
            custom: JSON.stringify(custom)
        };

        let res = await editFattura(username, token, fattura);
        if (res.result === 'ok') {
            
            await clearUscite(username, token, { id:  fattura.id, tipo: 'fattura' });
            for (const c of custom) {
                if (moment(c.data, 'DD/MM/yyyy').isSameOrBefore(moment())) {
                    await addUscita(username, token, { id: fattura.id, tipo: 'fattura', importo: c.importo, data: c.data });
                }
            }
            
            window.location.href = '/#/app/fatture';
            return;
        }

        this.setState({ isLoading: false });
        if (!res.error) {
            alert('Si è verificato un errore durante la creazione della fattura. Per favore, riprova.');
            return;
        }

        alert('Questo numero di fattura risulta già inserito per la ragione sociale indicata. Per favore, riprova.');

    }

}

